import { styled } from '@metrika/ui-kit/emotion';

export const PrivacyNoticeContainer = styled.div`
   position: fixed;
   z-index: ${({ theme }) => theme.zIndex.absoluteTop};

   bottom: 0;
   left: 0;
   right: 0;
   margin: 0 auto;

   display: flex;
   flex-direction: column;
   align-items: center;
   width: 100%;

   background-color: ${({ theme }) => theme.colors.ui01};
   box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.25);

   @media (min-width: ${({ theme }) => theme.mediaBreakpoints.md}) {
      flex-direction: row;
      width: 600px;
   }
`;

export const PrivacyNoticeText = styled.div`
   display: flex;
   flex-direction: column;
   flex-grow: 1;
   align-items: flex-start;
   padding: 1rem;

   h3 {
      ${({ theme }) => theme.typo.productiveHeading03}
   }

   p {
      ${({ theme }) => theme.typo.bodyLong01}
      margin-top: 0.5rem
   }

   & > div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-content: center;
      p {
         margin: 0;
      }
   }

   .hideMobile {
      display: none;
   }
   .showMobile {
      display: block;
   }
   @media (min-width: ${({ theme }) => theme.mediaBreakpoints.md}) {
      .hideMobile {
         display: block;
      }
      .showMobile {
         display: none;
      }
   }
`;

export const PrivacyNoticeButtons = styled.div`
   display: flex;
   flex-direction: row-reverse;
   align-items: flex-start;
   width: 100%;
   button {
      width: 50%;
   }

   @media (min-width: ${({ theme }) => theme.mediaBreakpoints.md}) {
      width: 10rem;
      flex-direction: column;
      margin: 1rem 1rem 1rem 0;
      button {
         width: 10rem;
         &:first-of-type {
            margin-bottom: 1rem;
         }
      }
   }
`;
